import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, API } from "../lib/http";
import axios from "axios";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("eata.user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  const persist = (token, refresh, u) => {
    localStorage.setItem("eata.token", token);
    localStorage.setItem("eata.refresh", refresh);
    localStorage.setItem("eata.user", JSON.stringify(u));
    setUser(u);
  };

  useEffect(() => {
    const token = localStorage.getItem("eata.token");
    if (!token) {
      setLoading(false);
      return;
    }
    http
      .get("/auth/me")
      .then((r) => {
        localStorage.setItem("eata.user", JSON.stringify(r.data));
        setUser(r.data);
      })
      .catch(() => {
        localStorage.removeItem("eata.token");
        localStorage.removeItem("eata.refresh");
        localStorage.removeItem("eata.user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    persist(r.data.access_token, r.data.refresh_token, r.data.user);
    return r.data.user;
  }, []);

  const loginWithGoogleSession = useCallback(async (sessionId) => {
    const r = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
    persist(r.data.access_token, r.data.refresh_token, r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await http.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("eata.token");
    localStorage.removeItem("eata.refresh");
    localStorage.removeItem("eata.user");
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginWithGoogleSession, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
